(function () {
  function init() {
    var root = document.getElementById('protein-quiz');
    if (!root || root.dataset.quizReady) return;
    root.dataset.quizReady = 'true';

    var form = root.querySelector('#quizForm');
    var btn = root.querySelector('#quizSubmitBtn');
    var result = root.querySelector('#result');
    if (!form || !btn || !result) return;

    var questions = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

    var PRODUCTS = {
      creamy: {
        type: 'Der Allrounder',
        tagline: 'Du willst ein Proteinpulver, das im Shaker genauso funktioniert wie in Pancakes, Porridge oder Muffins.',
        text: 'Ein cremiges, pflanzliches Proteinpulver passt am besten zu dir: klassische Sorten, milde Süße und vielseitig in der Küche einsetzbar.',
        name: 'Vetain Vegan Protein',
        url: '/collections/veganes-proteinpulver',
        cta: 'Zu den veganen Proteinpulvern'
      },
      clear: {
        type: 'Der Erfrischungs-Typ',
        tagline: 'Du magst es leicht und unkompliziert – Protein soll sich eher wie ein Getränk anfühlen als wie ein Milchshake.',
        text: 'Ein klares Proteinpulver passt am besten zu dir: fruchtig, leicht und mit Wasser angerührt wie eine Limo.',
        name: 'Vetain Clear Protein',
        url: '/collections/clear-protein',
        cta: 'Zu den Clear Proteinen'
      }
    };

    root.querySelectorAll('.opt input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (other) {
          other.closest('.opt').classList.toggle('opt-checked', other.checked);
        });
      });
    });

    function value(name) {
      var checked = form.querySelector('input[name="' + name + '"]:checked');
      return checked ? checked.value : null;
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function tips(a) {
      var list = [];
      if (a.q4 === 'vegan' || a.q4 === 'vegetarian') {
        list.push('Unsere Proteinpulver sind rein pflanzlich – passt also zu deiner Ernährung.');
      }
      if (a.q5 === 'very') {
        list.push('Wirf einen Blick auf die Zutatenliste: Wir verzichten auf Sucralose und unnötige Zusätze.');
      }
      if (a.q6 === 'yes' || a.q6 === 'sometimes') {
        list.push('Starte mit einer halben Portion und steigere dich langsam – so merkst du schnell, wie dein Bauch reagiert.');
        list.push('Pflanzliche Proteinpulver enthalten keine Laktose.');
      }
      if (a.q1 === 'cook') {
        list.push('Für Rezeptideen schau gern in unseren Rezepte-Blog.');
      }
      list.push('Unsicher bei der Sorte? Mit unseren Probierpackungen kannst du mehrere Geschmäcker testen.');
      return list;
    }

    function tipsHtml(a) {
      return '<div class="result-tip"><p class="tip-title">Tipps für dich</p><ul class="tip-list">' +
        tips(a).map(function (t) { return '<li>' + escapeHtml(t) + '</li>'; }).join('') +
        '</ul></div>';
    }

    function singleHtml(key, a) {
      var p = PRODUCTS[key];
      return '<p class="result-line">Dein Typ: ' + escapeHtml(p.type) + '</p>' +
        '<p class="result-tagline">' + escapeHtml(p.tagline) + '</p>' +
        '<div class="product-box"><p class="product-name">Unsere Empfehlung: ' + escapeHtml(p.name) + '</p>' +
        '<p class="result-text">' + escapeHtml(p.text) + '</p>' +
        '<a class="result-cta" href="' + p.url + '">' + escapeHtml(p.cta) + ' <span class="arrow">→</span></a></div>' +
        tipsHtml(a) +
        '<p class="tiny-note">Das Ergebnis ist eine Orientierung auf Basis deiner Antworten.</p>';
    }

    function cardHtml(key) {
      var p = PRODUCTS[key];
      return '<div class="result-card"><p class="card-title">' + escapeHtml(p.name) + '</p>' +
        '<p class="card-text">' + escapeHtml(p.text) + '</p>' +
        '<a class="card-cta" href="' + p.url + '">' + escapeHtml(p.cta) + ' <span class="arrow">→</span></a></div>';
    }

    function dualHtml(a) {
      return '<p class="dual-header">Dein Typ: Der Flexible</p>' +
        '<p class="dual-sub">Du bist offen für beides – cremig und klar. Viele kombinieren deshalb: cremig für Shakes und die Küche, klar als leichte Erfrischung zwischendurch.</p>' +
        '<div class="dual-grid">' + cardHtml('creamy') + cardHtml('clear') + '</div>' +
        tipsHtml(a) +
        '<p class="tiny-note">Das Ergebnis ist eine Orientierung auf Basis deiner Antworten.</p>';
    }

    // [creamy, clear] points per answer
    var WEIGHTS = {
      q1: { cook: [3, 0], shake: [2, 0], fresh: [0, 3], flex: [1, 1] },
      q2: { creamy: [2, 0], clear: [0, 2], both: [1, 1] },
      q3: { classic: [1, 0], fruity: [0, 1], neutral: [1, 0], open: [0, 0] }
    };

    function score(a) {
      var s = { creamy: 0, clear: 0 };
      Object.keys(WEIGHTS).forEach(function (q) {
        var w = WEIGHTS[q][a[q]];
        if (w) { s.creamy += w[0]; s.clear += w[1]; }
      });
      return s;
    }

    btn.addEventListener('click', function () {
      var answers = {};
      var missing = [];
      questions.forEach(function (q, i) {
        answers[q] = value(q);
        if (!answers[q]) missing.push(i + 1);
      });

      result.style.display = 'block';

      if (missing.length) {
        result.innerHTML = '<p class="result-text missing-note">Bitte beantworte noch ' +
          (missing.length === 1 ? 'Frage ' : 'die Fragen ') + missing.join(', ') + '.</p>';
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var s = score(answers);
      var diff = s.creamy - s.clear;
      result.innerHTML = Math.abs(diff) <= 1
        ? dualHtml(answers)
        : singleHtml(diff > 0 ? 'creamy' : 'clear', answers);
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
